<mat-expansion-panel
  [attr.status]="status()"
  (opened)="opened.set(true)"
  (closed)="opened.set(false)"
  [class.is-expanded]="opened()"
  [class.is-failed]="isFailed()"
  [class.is-success]="isSuccess()"
  [class.is-partial]="isPartial()"
  class="product-integration-accordion">
  <mat-expansion-panel-header class="product-integration-accordion-header">
    <mat-panel-title>
      <div class="header-info">
        <div class="header-top">
          <h3 class="product-name">{{ productName() }}</h3>
          <span class="product-codes">
            #{{ productCode() }}
            @if (ERPId()) {
              · ERP {{ ERPId() }}
            }
            @if (orderId()) {
              · Pedido {{ orderId() }}
            }
          </span>
        </div>
        <div class="header-status">
          @if (isFailed() && errorSummary()) {
            <!-- Não completado com motivo: a mensagem do ERP já diz o que houve, sem rótulo de status antes. -->
            <span class="error-message" [title]="opened() ? null : errorSummary()">
              <mat-icon aria-hidden="true">error</mat-icon>
              <span class="error-message-text">{{ errorSummary() }}</span>
            </span>
          } @else {
            <aionz-product-status [status]="status()"></aionz-product-status>
            @if (errorSummary()) {
              <span
                class="error-summary"
                [title]="opened() ? null : errorSummary()"
                >· {{ errorSummary() }}</span
              >
            }
          }
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="accordion-content">
    @if (suppliers().length > 0 || costCenters().length > 0 || branches().length > 0) {
      <dl class="info-grid">
        @if (suppliers().length > 0) {
          <div class="info-item">
            <dt>{{ suppliers().length === 1 ? 'Fornecedor' : 'Fornecedores' }}</dt>
            @for (supplier of suppliers(); track supplier) {
              <dd [title]="supplier">{{ supplier }}</dd>
            }
          </div>
        }
        @if (costCenters().length > 0) {
          <div class="info-item">
            <dt>{{ costCenters().length === 1 ? 'Centro de custo' : 'Centros de custo' }}</dt>
            @for (costCenter of costCenters(); track costCenter) {
              <dd [title]="costCenter">{{ costCenter }}</dd>
            }
          </div>
        }
        @if (branches().length > 0) {
          <div class="info-item">
            <dt>{{ branches().length === 1 ? 'Filial' : 'Filiais' }}</dt>
            @for (branch of branches(); track branch) {
              <dd [title]="branch">{{ branch }}</dd>
            }
          </div>
        }
      </dl>
    }
  </div>
</mat-expansion-panel>
